import gql from 'graphql-tag';

export const contactsByRelationId = gql`
  query contactsByRelationId($id: Int!)  {
    allContacts (condition: {relationId: $id}) {      
        nodes {
            id
            name
            department
            salesReference
            telWork
            telMobile
            email
            skype 
            }}
          }`

export const allContacts = gql`
  query allContacts  {
    allContacts  {      
        nodes {
            id
            selected
            name
            department
            salesReference
            telWork
            telMobile
            email
            skype
}}}`


export const createContact = gql`
  mutation (
            $relationId: Int!,
            $selected: Boolean,
            $name: String, 
            $department: String, 
            $salesReference: String,
            $telWork: String,
            $telMobile: String,
            $email: String,
            $skype: String,
            ){  
    createContact(input: {contact: { 
            relationId: $relationId,         
            selected: $selected,
            name: $name,
            department: $department,
            salesReference: $salesReference,
            telWork: $telWork,
            telMobile: $telMobile,
            email: $email,
            skype: $skype,
          }}) {
      contact {
        id               
      }     
    }
  }`

export const updateContactById = gql`
  mutation (
            $id: Int!,
            $selected: Boolean,
            $name: String ,
            $department: String, 
            $salesReference: String,
            $telWork: String,
            $telMobile: String,
            $email: String,
            $skype: String,
            ){
    updateContactById(input: {id: $id, contactPatch: {
            selected: $selected,
            name: $name,
            department: $department,
            salesReference: $salesReference,
            telWork: $telWork,
            telMobile: $telMobile,
            email: $email,
            skype: $skype     
      }}) { 
      contact {
        id               
      }     
    }
  }`

export const deleteContactById = gql`
    mutation deleteContactById($id: Int!) {
      deleteContactById(input: {id: $id}) {
        deletedContactId
  }
}
`


// WEBPACK FOOTER //
// ./src/queries/contacts.js